import React, { useState } from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { Tooltip } from '../Tooltip';
import { Button } from '../Button';

const meta: Meta<typeof Tooltip> = {
  title: 'Components/Tooltip',
  component: Tooltip,
};

export default meta;
type Story = StoryObj<typeof Tooltip>;

export const Default: Story = {
  args: {
    contents: 'This is a tooltip',
    children: <Button>Hover me</Button>,
  },
};

export const ClickOutside: Story = {
  render: ({ ...args }) => {
    const [show, setShow] = useState(false);

    return (
      <Tooltip
        {...args}
        onClickOutside={() => {
          setShow(false);
        }}
        show={show}
        contents="This is a popover"
        variant="popover"
      >
        <Button onClick={() => setShow(true)}>Click me</Button>
      </Tooltip>
    );
  },
};
